import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <TopicsSection />
        <AboutSection />
        <UpdatesSection />
        <FaqSection />
        <CarouselSection />
        <CommentsSection />
        <MediaSection />
        <CardsSection />
        <ContactSection />
        <RankingSection />
        <FeaturesSection />
        <IndexSection />
        <AppSection />
      </main>
      <Footer />
    </div>
  );
}